import { SVGProps } from 'react';

const Dribbble = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M12 2.25A9.75 9.75 0 0 1 21.75 12l-.012.48a9.752 9.752 0 0 1-2.843 6.415 9.747 9.747 0 0 1-1.952 1.506.746.746 0 0 1-.148.084c-.344.195-.698.371-1.064.523a9.752 9.752 0 0 1-3.252.73L12 21.75a9.751 9.751 0 0 1-9.738-9.27L2.25 12A9.751 9.751 0 0 1 12 2.25Zm2.55 11.846a12.3 12.3 0 0 0-2.412 1.01c-1.781.985-3.095 2.299-4.61 3.824A8.25 8.25 0 0 0 12 20.25l.405-.01a8.25 8.25 0 0 0 2.752-.618c.186-.077.368-.164.547-.254-.194-1.845-.558-3.567-1.153-5.272Zm5.587-.746c-1.596.017-2.95.154-4.125.385.526 1.536.88 3.094 1.096 4.74.253-.2.497-.412.726-.641a8.25 8.25 0 0 0 2.303-4.484Zm-1.769-6.594c-1.467 1.172-2.892 2.055-4.285 2.722.538.954.999 1.895 1.39 2.837 1.367-.29 2.934-.452 4.773-.465a8.247 8.247 0 0 0-1.878-5.094ZM8.715 4.434a8.25 8.25 0 0 0-4.718 5.561c2.66-.032 5.242-.243 7.911-1.224-.879-1.376-1.934-2.805-3.193-4.337ZM12 3.75c-.59 0-1.178.065-1.753.19 1.195 1.483 2.209 2.883 3.063 4.244 1.3-.61 2.624-1.42 3.995-2.5A8.249 8.249 0 0 0 12 3.75Zm-8.24 8.655a8.25 8.25 0 0 0 2.406 5.429c.056.056.114.11.172.164 1.545-1.558 3.04-3.079 5.074-4.204.78-.431 1.634-.8 2.595-1.099a25.258 25.258 0 0 0-1.309-2.618c-3.065 1.182-5.996 1.394-8.931 1.418-.01.168-.017.336-.017.505l.01.405Z"
    />
  </svg>
);

export default Dribbble;
